import Newshighlights from "./Home/Newshighlights";
import Facilities from "./Home/Facilities";
import Teachers from "./Home/Teachers";
import About from "./Home/About";
import Hero from "./Home/Hero";

function Home({img}) {  
    return (
      <div className=" gray-bg"> 
        <div className="search-box">
          <div className="serach-form">
            <div className="closebtn">
              <span />
              <span />
            </div>
            <form action="#">
              <input type="text" placeholder="Search by keyword" />
              <button><i className="fa fa-search" /></button>
            </form>
          </div> 
        </div>
        <Hero img={img}/>
        <About img={img}/>
        <Facilities img={img}/>
        <Teachers img={img}/>
        <Newshighlights img={img}/>
      </div>
    )
}

export default Home

